import { apiService } from './apiService';

export const fuelExceptionPointService = {
  getAll: () => apiService.get('/fuel-exception-points'),
  create: (data: unknown) => apiService.post('/fuel-exception-points', data),
  update: (id: string, data: unknown) => apiService.put(`/fuel-exception-points/${id}`, data),
  delete: (id: string) => apiService.delete(`/fuel-exception-points/${id}`),
};
